import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

@Injectable()
export class PaymentMethodsDataProvider {
	constructor(private http: HttpClient) {}

	deleteLang(url): any {
		return this.http.delete(url).toPromise();
	}

	getAllPaymentMethods() {
		return this.http.get('/protected/rest/payment_method').toPromise();
	}

	getPaymentInstructions() {
		return this.http.get('/api/user/payment-methods/instructions').toPromise();
	}

	savePaymentMethods(methodsToSave): any {
		return this.http
			.post('/api/user/payment-methods/instructions', methodsToSave)
			.toPromise();
	}

	getPaymetMethodByType(type) {
		return this.http
			.get(`/protected/rest/payment_method/get?type=${type}`)
			.toPromise();
	}

	saveStripeRequest(stripePaymentMethod): any {
		return this.http
			.post('/protected/rest/payment_method/save_stripe', stripePaymentMethod)
			.toPromise();
	}

	savePayPalRequest(paypalPaymentMethod): any {
		return this.http
			.post('/protected/rest/payment_method/save_paypal', paypalPaymentMethod)
			.toPromise();
	}
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/string-replace-webpack-plugin/loader.js?id=os2z8rc99lf!./web/modern/services/settings/payment-methods/payment-methods.data.service.ts